export enum PhoneType {
  CELL = "CELL",
  HOME = "HOME",
  MOBILE = "MOBILE",
  WORK = "WORK",
}
